import LaunchIcon from "@mui/icons-material/Launch";
import { Button, Stack, Typography } from "@mui/material";
import GlobusPersonalShareGuide from './components/GlobusPersonalShareGuide';

const GlobusShare = () => {
    const openGlobusShare = () => {
        window.open(window.env.globus.connect_personal_url, "_blank", "noopener,noreferrer");
    }

    return (
        <Stack gap={4}>
            <Typography fontWeight="600">
                Transfer the data through your institution’s secure Globus Share.
                You must first have a Globus account and share setup. To learn how to setup your Globus account you
                can consult this documentation.
            </Typography>

            <Stack flexDirection="row" alignItems="center" gap={4}>
                <Typography fontWeight="600">
                    Follow the steps below to setup your Globus Share and create a location for your transfers
                </Typography>

                <Button variant="secondary" endIcon={<LaunchIcon />}
                    onClick={openGlobusShare}>
                    Learn more
                </Button>
            </Stack>

            <GlobusPersonalShareGuide />
        </Stack>
    )
}

export default GlobusShare